import { BaseRequest } from 'planning-portal-library/src/lib/data/shared/base.request';
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { DistributionLaneRepository } from "../../repositories";
import { DistributionLane } from '../../domain';
import { BaseResponse } from 'planning-portal-library/src/lib/data/shared/base.response';

@Injectable({ providedIn: 'root' })
export class GetDistributionLanesUsecase implements UseCase<BaseRequest<any>,DistributionLane[]> {

  constructor(private DistributionLaneRepository: DistributionLaneRepository) {
  }

  execute(params: BaseRequest<any>): Observable<DistributionLane[]> {
    return this.DistributionLaneRepository.getDistributionLanes(params);
  }

}
